export const embeddedFormTypes = {
  SLATE: 'slate',
  IFRAME: 'iframe',
}

export const formTypeSelectOptions = [
  {name: 'Iframe', value: embeddedFormTypes.IFRAME},
  {name: 'Slate', value: embeddedFormTypes.SLATE},
]
